import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useMemo } from "react";
import "../infra.css";
import "../report.scss";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import "jspdf-autotable";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HC_more from "highcharts/highcharts-more";
import { useTranslation } from "react-i18next";
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);

//Function for Graph 1


export function SchoolGraph1006({ graphData, groupKeys, isNEP = true }) {
  const { t } = useTranslation();

  const map1 = useMemo(() => {
    const map = {};
    const managentBroad = {
      'State Govt.': 0,
      'Govt. Aided': 1,
      'Private Unaided': 2,
      'Central Govt.': 3,
      'Others': 4
    };
    const managentDetailed = {
      'Department of Education': 0,
      'Tribal Welfare Department': 1,
      'Local Body': 2,
      'Government Aided': 3,
      'Private Unaided (Recognized) ': 4,
      'Other State Govt. Managed ': 5,
      'Partially Govt. Aided': 6,
      'Unrecognized': 7,
      'Social Welfare Department': 8,
      'Ministry of Labour': 9,
      'Madrasa Private Unaided (Recognized) ': 10,
      'Madarsa Unrecognized': 11,
      'Madrasa Aided (Recognized)': 12,
      'Other Central Govt./PSU Schools': 13
    };

    if (isNEP) {
      if (groupKeys.schManagementBroad) {
        map.categories = Object.keys(managentBroad);
        map.series = [
          { name: 'Foundational and Preparatory', data: Array(5).fill(null) },
          { name: 'Middle', data: Array(5).fill(null) },
          { name: 'Secondary', data: Array(5).fill(null) }
        ];

        graphData.forEach(item => {
          const mgt = item['School Management(Broad)'];
          const index = managentBroad[mgt];
          if (index !== undefined) {
            map.series[0].data[index] = item['Foundational and Preparatory'] ?? null;
            map.series[1].data[index] = item['Middle'] ?? null;
            map.series[2].data[index] = item['Secondary'] ?? null;
          }
        });
      } else if (groupKeys.schManagementDesc) {
        map.categories = Object.keys(managentDetailed);
        const len = map.categories.length;
        map.series = [
          { name: 'Foundational and Preparatory', data: Array(len).fill(null) },
          { name: 'Middle', data: Array(len).fill(null) },
          { name: 'Secondary', data: Array(len).fill(null) }
        ];

        graphData.forEach(item => {
          const mgt = item['School Management(Detailed)'];
          const index = managentDetailed[mgt];
          if (index !== undefined) {
            map.series[0].data[index] = item['Foundational and Preparatory'] ?? null;
            map.series[1].data[index] = item['Middle'] ?? null;
            map.series[2].data[index] = item['Secondary'] ?? null;
          }
        });
      }
    } else {
      if (groupKeys.schManagementBroad) {
        map.categories = Object.keys(managentBroad);
        map.series = [
          { name: 'Pre Primary', data: Array(5).fill(null) },
          { name: 'Primary', data: Array(5).fill(null) },
          { name: 'Upper Primary', data: Array(5).fill(null) },
          { name: 'Secondary', data: Array(5).fill(null) },
          { name: 'Higher Secondary', data: Array(5).fill(null) }
        ];

        graphData.forEach(item => {
          const mgt = item['School Management(Broad)'];
          const index = managentBroad[mgt];
          if (index !== undefined) {
            map.series[0].data[index] = item['Pre Primary'] ?? null;
            map.series[1].data[index] = item['Primary'] ?? null;
            map.series[2].data[index] = item['Upper Primary'] ?? null;
            map.series[3].data[index] = item['Secondary'] ?? null;
            map.series[4].data[index] = item['Higher Secondary'] ?? null;
          }
        });
      } else if (groupKeys.schManagementDesc) {
        map.categories = Object.keys(managentDetailed);
        const len = map.categories.length;
        map.series = [
          { name: 'Pre Primary', data: Array(len).fill(null) },
          { name: 'Primary', data: Array(len).fill(null) },
          { name: 'Upper Primary', data: Array(len).fill(null) },
          { name: 'Secondary', data: Array(len).fill(null) },
          { name: 'Higher Secondary', data: Array(len).fill(null) }
        ];

        graphData.forEach(item => {
          const mgt = item['School Management(Detailed)'];
          const index = managentDetailed[mgt];
          if (index !== undefined) {
            map.series[0].data[index] = item['Pre Primary'] ?? null;
            map.series[1].data[index] = item['Primary'] ?? null;
            map.series[2].data[index] = item['Upper Primary'] ?? null;
            map.series[3].data[index] = item['Secondary'] ?? null;
            map.series[4].data[index] = item['Higher Secondary'] ?? null;
          }
        });
      }
    }

    return map;
  }, [graphData, groupKeys, isNEP]);

  return (
    <div className="impact-box-content-education">
      <div className="piechart-box mt-5 pb-5">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: "column",
              marginTop: 50,
              events: {
                beforePrint: function () {
                  this.exportSVGElements[0]?.box?.hide?.();
                  this.exportSVGElements[1]?.hide?.();
                },
                afterPrint: function () {
                  this.exportSVGElements[0]?.box?.show?.();
                  this.exportSVGElements[1]?.show?.();
                },
              },
            },
            xAxis: {
              categories: map1.categories,
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: { text: "" },
            },
            title: {
              text: t("total_teachers_by_management_category"),
              style: { fontSize: '15px' }
            },
            tooltip: {
              headerFormat: "<b>{point.x}</b><br/>",
              pointFormatter: function () {
                return `<span style="color:${this.color}">\u25CF</span> ${
                  this.series.name
                }: <b>${this.y?.toLocaleString("en-IN")}</b><br/>`;
              },
            },
            plotOptions: {
              column: {
                stacking: "normal",
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return this.y?.toLocaleString("en-IN");
                  },
                  style: {
                    font: "13px Arial, sans-serif",
                    fontWeight: "600",
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemMarginTop: 10,
              itemMarginBottom: 10,
            },
            credits: { enabled: false },
            series: map1.series,
            exporting: {
              filename: t("total_teacher_by_management_category"),
              csv: {
                columnHeaderFormatter: function (item) {
                  if (!item || item instanceof Highcharts.Axis) return t("category");
                  return item.name;
                },
              },
            },
          }}
          immutable={true}
        />
      </div>
    </div>
  );
}

/////////////////////////////////////              End SchoolGraph1006 graph components        /////////////////////////////////////////////////////////

export function SchoolGraphCat1006({ graphData,  groupKeys, isNEP }) {
  console.log('graphData', graphData)
const { t } = useTranslation();
const map1={};
const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};

if(isNEP){
  if(groupKeys.schCategoryBroad){
  map1.categories=['Foundational and Preparatory', 'Middle', 'Secondary'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'State Govt.', data: [0, 0, 0] },
      { name: 'Govt. Aided', data: [0, 0, 0] },
      { name: 'Private Unaided', data: [0, 0, 0] },
      { name: 'Central Govt.', data: [0, 0, 0] },
      { name: 'Others', data: [0, 0, 0] }
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][index].data = [map1['series'][index].data[0]+item['Foundational and Preparatory'],map1['series'][index].data[1]+item['Middle'],map1['series'][index].data[2]+item['Secondary']]; ;
      // map1['series'][1].data[index] = item['Middle'];
      // map1['series'][2].data[index] = item['Secondary'];
    }
  });

  console.log("map1-----",map1)

}else if(groupKeys.schCategoryDesc){
  map1.categories=['Foundational and Preparatory','Middle (1-8)','Middle (6-8)','Secondary (1-10)','Secondary (1-12)','Secondary (6-10)','Secondary (6-12)','Secondary (9-10)','Secondary (9-12)','Secondary (11-12)'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'State Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Govt. Aided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Private Unaided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Central Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Others', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] }
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][index].data = [map1['series'][index].data[0]+item['Foundational and Preparatory'],map1['series'][index].data[1]+item['Middle (1-8)'], map1['series'][index].data[2]+item['Middle (6-8)'], map1['series'][index].data[3]+item['Secondary (1-10)'], map1['series'][index].data[4]+item['Secondary (1-12)'] , map1['series'][index].data[5]+item['Secondary (6-10)'] , map1['series'][index].data[6]+item['Secondary (6-12)'], map1['series'][index].data[7]+item['Secondary (9-10)'], map1['series'][index].data[8]+item['Secondary (9-12)'], map1['series'][index].data[9]+item['Secondary (11-12)']] ;
    }
  });
}
}else{
  if(groupKeys.schCategoryBroad){
  map1.categories=['Pre Primary', 'Primary', 'Upper Primary', 'Secondary', 'Higher Secondary'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'State Govt.', data: [0, 0, 0] },
      { name: 'Govt. Aided', data: [0, 0, 0] },
      { name: 'Private Unaided', data: [0, 0, 0] },
      { name: 'Central Govt.', data: [0, 0, 0] },
      { name: 'Others', data: [0, 0, 0] }
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][index].data = [map1['series'][index].data[0]+item['Pre Primary'],
      map1['series'][index].data[1]+item['Primary'],
      map1['series'][index].data[2]+item['Upper Primary'],
      map1['series'][index].data[2]+item['Secondary'],
      map1['series'][index].data[2]+item['Higher Secondary'],
]; 
    }
  });

  console.log("map1-----",map1)

}else if(groupKeys.schCategoryDesc){
  map1.categories=['Primary (1-5)','Middle (1-8)','Middle (6-8)','Secondary (1-10)','Secondary (1-12)','Secondary (6-10)','Secondary (6-12)','Secondary (9-10)','Secondary (9-12)','Secondary (11-12)'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'State Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Govt. Aided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Private Unaided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Central Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
      { name: 'Others', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] }
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][index].data = [map1['series'][index].data[0]+item['Primary (1-5)'],map1['series'][index].data[1]+item['Middle (1-8)'], map1['series'][index].data[2]+item['Middle (6-8)'], map1['series'][index].data[3]+item['Secondary (1-10)'], map1['series'][index].data[4]+item['Secondary (1-12)'] , map1['series'][index].data[5]+item['Secondary (6-10)'] , map1['series'][index].data[6]+item['Secondary (6-12)'], map1['series'][index].data[7]+item['Secondary (9-10)'], map1['series'][index].data[8]+item['Secondary (9-12)'], map1['series'][index].data[9]+item['Secondary (11-12)']] ;
    }
  });
}
}

  return (
    <div className="impact-box-content-education">
  
      <div className="piechart-box mt-5 pb-5">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: "column",
              marginTop: 50,
              events: {
                beforePrint: function () {
                  this.exportSVGElements[0].box.hide();
                  this.exportSVGElements[1].hide();
                },
                afterPrint: function () {
                  this.exportSVGElements[0].box.show();
                  this.exportSVGElements[1].show();
                },
              },
            },
            xAxis: {
              categories: map1.categories,
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: "",
              },
            },
            title: {
              text: t("total_teachers_by_management_category"),
              style: {
                fontSize: '15px'  
              }
            },
            tooltip: {
              headerFormat: "<b>{point.x}</b><br/>",
              pointFormat: "{series.name}: {point.y}",
              pointFormatter: function () {
                return `<span style="color:${this.color}">\u25CF</span> ${
                  this.series.name
                }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
              },
            },
            plotOptions: {
              column: {
                stacking: "normal",
                dataLabels: {
                  enabled: true,
                  crop: false,
                  overflow: "none",
                  rotation: 0,
                  align: "center",
                  x: -2,
                  y: -5,
                  style: {
                    font: "13px Arial, sans-serif",
                    fontWeight: "600",
                    stroke: "transparent",
                    align: "center",
                  },
                  position: "top",
                  formatter: function () {
                    // return parseFloat(
                    //   this.y
                    // ).toFixed(0);
                    return this.y.toLocaleString("en-IN");
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemMarginTop: 10,
              itemMarginBottom: 10,
            },
            credits: {
              enabled: false,
            },
            series: map1.series,
            exporting: {
              filename: t("total_teacher_by_management_category"),
              csv: {
                columnHeaderFormatter: function (item) {
                  if (!item || item instanceof Highcharts.Axis) {
                    return t("category");
                  }
                  return item.name;
                },
              },
            },
          }}
          immutable={true}
        />
      </div>
    </div>
  );
}

export function SchoolGraph2Manage1006({ graphData,  groupKeys }) {
    const { t } = useTranslation();
    const map1=[0,0,0,0,0];
    const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
    const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)':14};
    
    
    // if(groupKeys.schCategoryBroad){
    
  console.log("graphData-----",graphData)
  
      graphData.forEach((item) => {
        const managementType = item['School Management(Broad)'];
        if (managentBroad[managementType] !== undefined) {
          const index = managentBroad[managementType];
          map1[index]=map1[index]+item['Overall'];
        }
      });
    
      console.log("map1----------------",map1)
    console.log("map1----",map1);
    const total = map1.reduce((sum, value) => sum + value, 0);
    console.log("Others---",((map1[4] / total)*100).toFixed(2))
      return (
         <div className="piechart-box mt-4">
                                      <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                          chart: {
                                            type: "pie",
                                            marginTop: 50,
                                            events: {
                                              beforePrint: function () {
                                                this.exportSVGElements[0].box.hide();
                                                this.exportSVGElements[1].hide();
                                              },
                                              afterPrint: function () {
                                                this.exportSVGElements[0].box.show();
                                                this.exportSVGElements[1].show();
                                              },
                                            },
                                          },
                                          events: {
                                            beforePrint: function () {},
                                            afterPrint: function () {},
                                          },
                                          title: {
                                            text: t("percentage_schools_by_management"),
                                          },
                                          tooltip: {
                                            valueSuffix: "%",
                                            valueDecimals: 2,
                                          },
                                          credits: {
                                            enabled: false,
                                          },
                                          plotOptions: {
                                            pie: {
                                              size: "100%",
                                              dataLabels: {
                                                enabled: true,
                                                distance: -40,
                                                formatter: function () {
                                                  return "<b>" + this.point.y + "%";
                                                },
                                                style: {
                                                  fontSize: "16px",
                                                  textOutline: "none",
                                                  opacity: 0.7,
                                                },
                                              },
                                              center: ["50%", "50%"],
                                              showInLegend: true,
                                            },
                                            series: {
                                              allowPointSelect: true,
                                              cursor: "pointer",
                                              dataLabels: [
                                                {
                                                  enabled: true,
                                                  distance: 20,
                                                },
                                                {
                                                  enabled: false,
                                                  distance: -40,
                                                  format: "{point.y:.2f}%",
                                                  style: {
                                                    fontSize: "0.6em",
                                                    textOutline: "none",
                                                    opacity: 0.7,
                                                  },
        
                                                  filter: {
                                                    operator: ">",
                                                    property: "percentage",
                                                    value: 0,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                          legend: {
                                            // title: {
                                            //   text: "Key",
                                            //   style: {
                                            //     fontSize: "18px",
                                            //   },
                                            // },
                                            layout: "horizontal",
                                            align: "center",
                                            verticalAlign: "bottom",
                                            itemMarginTop: 10,
                                            itemMarginBottom: 10,
                                          },
                                          series: [
                                            {
                                              name: t("percentage"),
                                              colorByPoint: true,
                                              data: [
                                                {
                                                  name: 'State Govt.',
                                                  y: parseFloat((map1[0] / total).toFixed(4) * 100),
                                                  color: "#F5BF55",
                                                },
        
                                                {
                                                  name: 'Govt. Aided',
                                                  y: parseFloat(((map1[1] / total)*100).toFixed(2)),
                                                  color: "#E6694A",
                                                },
                                                {
                                                  name: 'Private Unaided',
                                                  y:parseFloat(((map1[2] / total)*100).toFixed(2)),
                                                  color: "#BCE263",
                                                },
        
                                                {
                                                  name: 'Central Govt.',
                                                  y: parseFloat((map1[3] / total).toFixed(4) * 100),
                                                  color: "#1d1575",
                                                },
                                                {
                                                  name: 'Others',
                                                  y: parseFloat(((map1[4] / total)*100).toFixed(2)),
                                                  color: "#751539",
                                                }
                                                // {
                                                //   name: 'Others',
                                                //   y: parseFloat((map1[4] / total).toFixed(4) * 100),
                                                //   color: "#751539",
                                                // }
                                              ],
                                            },
                                          ],
                                          exporting: {
                                            filename: t(
                                              "percentage_schools_by_management"
                                            ),
                                            csv: {
                                              columnHeaderFormatter: function (item) {
                                                if (
                                                  !item ||
                                                  item instanceof Highcharts.Axis
                                                ) {
                                                  return t("category");
                                                }
                                                return item.name;
                                              },
                                            },
                                          },
                                        }}
                                        immutable={true}
                                      />
                                    </div>
      );
}

export function SchoolGraph2Cat1006({ graphData,  groupKeys, isNEP }) {
      const { t } = useTranslation();
      const map1=[0,0,0,0,0];
      let dataSet;
      console.log('graphData', graphData)

    
      if(isNEP){
         graphData.forEach((item) => {
          map1[0]=(map1[0]+item['Foundational and Preparatory']);
          map1[1]=(map1[1]+item['Middle']);
          map1[2]=(map1[2]+item['Secondary']);
        });

      const total = map1.reduce((sum, value) => sum + value, 0);

      
        dataSet = [
          {
            name: "Foundational and Preparatory",
            y: parseFloat(((map1[0] / total) * 100).toFixed(2)),
            color: "#F5BF55",
          },

          {
            name: "Middle",
            y: parseFloat(((map1[1] / total) * 100).toFixed(2)),
            color: "#E6694A",
          },
          {
            name: "Secondary",
            y: parseFloat(((map1[2] / total) * 100).toFixed(2)),
            color: "#BCE263",
          },
        ];
      }else{
           graphData.forEach((item) => {
          map1[0]=(map1[0]+item['Pre Primary']);
          map1[1]=(map1[1]+item['Primary']);
          map1[2]=(map1[2]+item['Upper Primary']);
          map1[2]=(map1[2]+item['Secondary']);
          map1[2]=(map1[2]+item['Higher Secondary']);
        });

      const total = map1.reduce((sum, value) => sum + value, 0);

      
        dataSet = [
          {
            name: "Pre Primary",
            y: parseFloat(((map1[0] / total) * 100).toFixed(2)),
            color: "#F5BF55",
          },

          {
            name: "Primary",
            y: parseFloat(((map1[1] / total) * 100).toFixed(2)),
            color: "#E6694A",
          },
          {
            name: "Upper Primary",
            y: parseFloat(((map1[2] / total) * 100).toFixed(2)),
            color: "#BCE263",
          },
          {
            name: "Secondary",
            y: parseFloat(((map1[2] / total) * 100).toFixed(2)),
            color: "#1d1575",
          },
          {
            name: "Higher Secondary",
            y: parseFloat(((map1[2] / total) * 100).toFixed(2)),
            color: "#751539",
          },
        ];
      }
       
    
        return (
           <div className="piechart-box mt-4">
                                        <HighchartsReact
                                          highcharts={Highcharts}
                                          options={{
                                            chart: {
                                              type: "pie",
                                              marginTop: 50,
                                              events: {
                                                beforePrint: function () {
                                                  this.exportSVGElements[0].box.hide();
                                                  this.exportSVGElements[1].hide();
                                                },
                                                afterPrint: function () {
                                                  this.exportSVGElements[0].box.show();
                                                  this.exportSVGElements[1].show();
                                                },
                                              },
                                            },
                                            events: {
                                              beforePrint: function () {},
                                              afterPrint: function () {},
                                            },
                                            title: {
                                              text: t("percentage_schools_by_management"),
                                            },
                                            tooltip: {
                                              valueSuffix: "%",
                                              valueDecimals: 2,
                                            },
                                            credits: {
                                              enabled: false,
                                            },
                                            plotOptions: {
                                              pie: {
                                                size: "100%",
                                                dataLabels: {
                                                  enabled: true,
                                                  distance: -40,
                                                  formatter: function () {
                                                    return "<b>" + this.point.y + "%";
                                                  },
                                                  style: {
                                                    fontSize: "16px",
                                                    textOutline: "none",
                                                    opacity: 0.7,
                                                  },
                                                },
                                                center: ["50%", "50%"],
                                                showInLegend: true,
                                              },
                                              series: {
                                                allowPointSelect: true,
                                                cursor: "pointer",
                                                dataLabels: [
                                                  {
                                                    enabled: true,
                                                    distance: 20,
                                                  },
                                                  {
                                                    enabled: false,
                                                    distance: -40,
                                                    format: "{point.y:.2f}%",
                                                    style: {
                                                      fontSize: "0.6em",
                                                      textOutline: "none",
                                                      opacity: 0.7,
                                                    },
          
                                                    filter: {
                                                      operator: ">",
                                                      property: "percentage",
                                                      value: 0,
                                                    },
                                                  },
                                                ],
                                              },
                                            },
                                            legend: {
                                              // title: {
                                              //   text: "Key",
                                              //   style: {
                                              //     fontSize: "18px",
                                              //   },
                                              // },
                                              layout: "horizontal",
                                              align: "center",
                                              verticalAlign: "bottom",
                                              itemMarginTop: 10,
                                              itemMarginBottom: 10,
                                            },
                                            series: [
                                              {
                                                name: t("percentage"),
                                                colorByPoint: true,
                                                data: dataSet,
                                              },
                                            ],
                                            exporting: {
                                              filename: t(
                                                "percentage_schools_by_management"
                                              ),
                                              csv: {
                                                columnHeaderFormatter: function (item) {
                                                  if (
                                                    !item ||
                                                    item instanceof Highcharts.Axis
                                                  ) {
                                                    return t("category");
                                                  }
                                                  return item.name;
                                                },
                                              },
                                            },
                                          }}
                                          immutable={true}
                                        />
                                      </div>
        );
}

// export function SchoolGraph1007({ graphData,  groupKeys, isNEP }) {
//   const { t } = useTranslation();
// console.log("graphData-----",graphData);
// console.log("  groupKeys----",  groupKeys);
// const map1={};
// const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
// const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)':14};



// if(isNEP){
//   if(groupKeys.schManagementBroad){
//   map1.categories=['State Govt.', 'Govt. Aided', 'Private Unaided', 'Central Govt.', 'Others'];
//   if (!map1['series']) {
//     map1['series'] = [
//       { name: 'Foundational and Preparatory', data: [null, null, null, null] },
//       { name: 'Middle', data: [null, null, null, null] },
//       { name: 'Secondary', data: [null, null, null, null] }
//     ];
//   }
//   graphData.forEach((item) => {
//     const managementType = item['School Management(Broad)'];
//     if (managentBroad[managementType] !== undefined) {
//       const index = managentBroad[managementType];
//       map1['series'][0].data[index] = item['Foundational and Preparatory'];
//       map1['series'][1].data[index] = item['Middle'];
//       map1['series'][2].data[index] = item['Secondary'];
//     }
//   });
// }else if(groupKeys.schManagementDesc){
//   map1.categories=['Department of Education', 'Tribal Welfare Department', 'Local Body', 'Government Aided', 'Private Unaided (Recognized) ', 'Other State Govt. Managed ', 'Partially Govt. Aided', 'Unrecognized', 'Social Welfare Department', 'Ministry of Labour', 'Madrasa Private Unaided (Recognized) ', 'Madarsa Unrecognized', 'Madrasa Aided (Recognized)', 'Other Central Govt./PSU Schools', 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)':14];
//   if (!map1['series']) {
//     map1['series'] = [
//       { name: 'Foundational and Preparatory', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
//       { name: 'Middle', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
//       { name: 'Secondary', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] }
//     ];
//   }
//   graphData.forEach((item) => {
//     const managementType = item['School Management(Detailed)'];
//     if (managentDetailed[managementType] !== undefined) {
//       const index = managentDetailed[managementType];
//       map1['series'][0].data[index] = item['Foundational and Preparatory'];
//       map1['series'][1].data[index] = item['Middle'];
//       map1['series'][2].data[index] = item['Secondary'];
//     }
//   });
// }
// }else if(!isNEP){
  
// }

//   return (
//     <div className="impact-box-content-education">
  
//       <div className="piechart-box mt-5 pb-5">
//         <HighchartsReact
//           highcharts={Highcharts}
//           options={{
//             chart: {
//               type: "column",
//               marginTop: 50,
//               events: {
//                 beforePrint: function () {
//                   this.exportSVGElements[0].box.hide();
//                   this.exportSVGElements[1].hide();
//                 },
//                 afterPrint: function () {
//                   this.exportSVGElements[0].box.show();
//                   this.exportSVGElements[1].show();
//                 },
//               },
//             },
//             xAxis: {
//               categories: map1.categories,
//             },
//             yAxis: {
//               allowDecimals: false,
//               min: 0,
//               title: {
//                 text: "",
//               },
//             },
//             title: {
//               text: t("total_teachers_by_management_category"),
//               style: {
//                 fontSize: '15px'  
//               }
//             },
//             tooltip: {
//               headerFormat: "<b>{point.x}</b><br/>",
//               pointFormat: "{series.name}: {point.y}",
//               pointFormatter: function () {
//                 return `<span style="color:${this.color}">\u25CF</span> ${
//                   this.series.name
//                 }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
//               },
//             },
//             plotOptions: {
//               column: {
//                 stacking: "normal",
//                 dataLabels: {
//                   enabled: true,
//                   crop: false,
//                   overflow: "none",
//                   rotation: 0,
//                   align: "center",
//                   x: -2,
//                   y: -5,
//                   style: {
//                     font: "13px Arial, sans-serif",
//                     fontWeight: "600",
//                     stroke: "transparent",
//                     align: "center",
//                   },
//                   position: "top",
//                   formatter: function () {
//                     // return parseFloat(
//                     //   this.y
//                     // ).toFixed(0);
//                     return this.y.toLocaleString("en-IN");
//                   },
//                 },
//               },
//             },
//             legend: {
//               layout: "horizontal",
//               align: "center",
//               verticalAlign: "bottom",
//               itemMarginTop: 10,
//               itemMarginBottom: 10,
//             },
//             credits: {
//               enabled: false,
//             },
//             series: map1.series,
//             exporting: {
//               filename: t("total_teacher_by_management_category"),
//               csv: {
//                 columnHeaderFormatter: function (item) {
//                   if (!item || item instanceof Highcharts.Axis) {
//                     return t("category");
//                   }
//                   return item.name;
//                 },
//               },
//             },
//           }}
//           immutable={true}
//         />
//       </div>
//     </div>
//   );
// }

// export function SchoolGraphCat1007({ graphData,  groupKeys }) {
//   const { t } = useTranslation();
//   const map1={};
//   const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
//   const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)':14};
  
  
//   if(groupKeys.schCategoryBroad){
//     map1.categories=['Foundational and Preparatory', 'Middle', 'Secondary'];
//     if (!map1['series']) {
//       map1['series'] = [
//         { name: 'State Govt.', data: [0, 0, 0] },
//         { name: 'Govt. Aided', data: [0, 0, 0] },
//         { name: 'Private Unaided', data: [0, 0, 0] },
//         { name: 'Central Govt.', data: [0, 0, 0] },
//         { name: 'Others', data: [0, 0, 0] }
//       ];
//     }
//     graphData.forEach((item) => {
//       const managementType = item['School Management(Broad)'];
//       if (managentBroad[managementType] !== undefined) {
//         const index = managentBroad[managementType];
//         map1['series'][index].data = [map1['series'][index].data[0]+item['Foundational and Preparatory'],map1['series'][index].data[1]+item['Middle'],map1['series'][index].data[2]+item['Secondary']]; ;
//         // map1['series'][1].data[index] = item['Middle'];
//         // map1['series'][2].data[index] = item['Secondary'];
//       }
//     });
  
//     console.log("map1-----",map1)
  
//   }else if(groupKeys.schCategoryDesc){
//     map1.categories=['Foundational and Preparatory','Middle (1-8)','Middle (6-8)','Secondary (1-10)','Secondary (1-12)','Secondary (6-10)','Secondary (6-12)','Secondary (9-10)','Secondary (9-12)','Secondary (11-12)'];
//     if (!map1['series']) {
//       map1['series'] = [
//         { name: 'State Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
//         { name: 'Govt. Aided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
//         { name: 'Private Unaided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
//         { name: 'Central Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
//         { name: 'Others', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] }
//       ];
//     }
//     graphData.forEach((item) => {
//       const managementType = item['School Management(Broad)'];
//       if (managentBroad[managementType] !== undefined) {
//         const index = managentBroad[managementType];
//         map1['series'][index].data = [map1['series'][index].data[0]+item['Foundational and Preparatory'],map1['series'][index].data[1]+item['Middle (1-8)'], map1['series'][index].data[2]+item['Middle (6-8)'], map1['series'][index].data[3]+item['Secondary (1-10)'], map1['series'][index].data[4]+item['Secondary (1-12)'] , map1['series'][index].data[5]+item['Secondary (6-10)'] , map1['series'][index].data[6]+item['Secondary (6-12)'], map1['series'][index].data[7]+item['Secondary (9-10)'], map1['series'][index].data[8]+item['Secondary (9-12)'], map1['series'][index].data[9]+item['Secondary (11-12)']] ;
//       }
//     });
//   }
//     return (
//       <div className="impact-box-content-education">
    
//         <div className="piechart-box mt-5 pb-5">
//           <HighchartsReact
//             highcharts={Highcharts}
//             options={{
//               chart: {
//                 type: "column",
//                 marginTop: 50,
//                 events: {
//                   beforePrint: function () {
//                     this.exportSVGElements[0].box.hide();
//                     this.exportSVGElements[1].hide();
//                   },
//                   afterPrint: function () {
//                     this.exportSVGElements[0].box.show();
//                     this.exportSVGElements[1].show();
//                   },
//                 },
//               },
//               xAxis: {
//                 categories: map1.categories,
//               },
//               yAxis: {
//                 allowDecimals: false,
//                 min: 0,
//                 title: {
//                   text: "",
//                 },
//               },
//               title: {
//                 text: t("total_teachers_by_management_category"),
//                 style: {
//                   fontSize: '15px'  
//                 }
//               },
//               tooltip: {
//                 headerFormat: "<b>{point.x}</b><br/>",
//                 pointFormat: "{series.name}: {point.y}",
//                 pointFormatter: function () {
//                   return `<span style="color:${this.color}">\u25CF</span> ${
//                     this.series.name
//                   }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
//                 },
//               },
//               plotOptions: {
//                 column: {
//                   stacking: "normal",
//                   dataLabels: {
//                     enabled: true,
//                     crop: false,
//                     overflow: "none",
//                     rotation: 0,
//                     align: "center",
//                     x: -2,
//                     y: -5,
//                     style: {
//                       font: "13px Arial, sans-serif",
//                       fontWeight: "600",
//                       stroke: "transparent",
//                       align: "center",
//                     },
//                     position: "top",
//                     formatter: function () {
//                       // return parseFloat(
//                       //   this.y
//                       // ).toFixed(0);
//                       return this.y.toLocaleString("en-IN");
//                     },
//                   },
//                 },
//               },
//               legend: {
//                 layout: "horizontal",
//                 align: "center",
//                 verticalAlign: "bottom",
//                 itemMarginTop: 10,
//                 itemMarginBottom: 10,
//               },
//               credits: {
//                 enabled: false,
//               },
//               series: map1.series,
//               exporting: {
//                 filename: t("total_teacher_by_management_category"),
//                 csv: {
//                   columnHeaderFormatter: function (item) {
//                     if (!item || item instanceof Highcharts.Axis) {
//                       return t("category");
//                     }
//                     return item.name;
//                   },
//                 },
//               },
//             }}
//             immutable={true}
//           />
//         </div>
//       </div>
//     );
//   }


  export function SchoolGraph2Manage1007({ graphData,  groupKeys }) {
    const { t } = useTranslation();
    const map1=[0,0,0,0,0];
    const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
    const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)':14};
    
    
    // if(groupKeys.schCategoryBroad){
    
  console.log("graphData-----",graphData)
  
      graphData.forEach((item) => {
        const managementType = item['School Management(Broad)'];
        if (managentBroad[managementType] !== undefined) {
          const index = managentBroad[managementType];
          map1[index]=map1[index]+item['Overall'];
        }
      });
    const total = map1.reduce((sum, value) => sum + value, 0);
    console.log("Others---",((map1[4] / total)*100).toFixed(2));

      return (
         <div className="piechart-box mt-4">
                                      <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                          chart: {
                                            type: "pie",
                                            marginTop: 50,
                                            events: {
                                              beforePrint: function () {
                                                this.exportSVGElements[0].box.hide();
                                                this.exportSVGElements[1].hide();
                                              },
                                              afterPrint: function () {
                                                this.exportSVGElements[0].box.show();
                                                this.exportSVGElements[1].show();
                                              },
                                            },
                                          },
                                          events: {
                                            beforePrint: function () {},
                                            afterPrint: function () {},
                                          },
                                          title: {
                                            text: t("percentage_schools_by_management"),
                                          },
                                          tooltip: {
                                            valueSuffix: "%",
                                            valueDecimals: 2,
                                          },
                                          credits: {
                                            enabled: false,
                                          },
                                          plotOptions: {
                                            pie: {
                                              size: "100%",
                                              dataLabels: {
                                                enabled: true,
                                                distance: -40,
                                                formatter: function () {
                                                  return "<b>" + this.point.y + "%";
                                                },
                                                style: {
                                                  fontSize: "16px",
                                                  textOutline: "none",
                                                  opacity: 0.7,
                                                },
                                              },
                                              center: ["50%", "50%"],
                                              showInLegend: true,
                                            },
                                            series: {
                                              allowPointSelect: true,
                                              cursor: "pointer",
                                              dataLabels: [
                                                {
                                                  enabled: true,
                                                  distance: 20,
                                                },
                                                {
                                                  enabled: false,
                                                  distance: -40,
                                                  format: "{point.y:.2f}%",
                                                  style: {
                                                    fontSize: "0.6em",
                                                    textOutline: "none",
                                                    opacity: 0.7,
                                                  },
        
                                                  filter: {
                                                    operator: ">",
                                                    property: "percentage",
                                                    value: 0,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                          legend: {
                                            // title: {
                                            //   text: "Key",
                                            //   style: {
                                            //     fontSize: "18px",
                                            //   },
                                            // },
                                            layout: "horizontal",
                                            align: "center",
                                            verticalAlign: "bottom",
                                            itemMarginTop: 10,
                                            itemMarginBottom: 10,
                                          },
                                          series: [
                                            {
                                              name: t("percentage"),
                                              colorByPoint: true,
                                              data: [
                                                {
                                                  name: 'State Govt.',
                                                  y: parseFloat(((map1[0] / total)*100).toFixed(2)),
                                                  color: "#F5BF55",
                                                },
        
                                                {
                                                  name: 'Govt. Aided',
                                                  y:parseFloat(((map1[1] / total)*100).toFixed(2)),
                                                  color: "#E6694A",
                                                },
                                                {
                                                  name: 'Private Unaided',
                                                  y:parseFloat(((map1[2] / total)*100).toFixed(2)),
                                                  color: "#BCE263",
                                                },
        
                                                {
                                                  name: 'Central Govt.',
                                                  y: parseFloat(((map1[3] / total)*100).toFixed(2)),
                                                  color: "#1d1575",
                                                },
                                                {
                                                  name: 'Others',
                                                  y: parseFloat(((map1[4] / total)*100).toFixed(2)),
                                                  color: "#751539",
                                                }
                                                // {
                                                //   name: 'Others',
                                                //   y: parseFloat((map1[4] / total).toFixed(4) * 100),
                                                //   color: "#751539",
                                                // }
                                              ],
                                            },
                                          ],
                                          exporting: {
                                            filename: t(
                                              "percentage_schools_by_management"
                                            ),
                                            csv: {
                                              columnHeaderFormatter: function (item) {
                                                if (
                                                  !item ||
                                                  item instanceof Highcharts.Axis
                                                ) {
                                                  return t("category");
                                                }
                                                return item.name;
                                              },
                                            },
                                          },
                                        }}
                                        immutable={true}
                                      />
                                    </div>
      );
}

// export function SchoolGraph2Cat1007({ graphData,  groupKeys }) {
//       const { t } = useTranslation();
//       const map1=[0,0,0];
//       console.log('graphData', graphData)

    
//         graphData.forEach((item) => {
//           map1[0]=(map1[0]+item['Foundational and Preparatory']);
//           map1[1]=(map1[1]+item['Middle']);
//           map1[2]=(map1[2]+item['Secondary']);
//         });


//       const total = map1.reduce((sum, value) => sum + value, 0);
    
//         return (
//            <div className="piechart-box mt-4">
//                                         <HighchartsReact
//                                           highcharts={Highcharts}
//                                           options={{
//                                             chart: {
//                                               type: "pie",
//                                               marginTop: 50,
//                                               events: {
//                                                 beforePrint: function () {
//                                                   this.exportSVGElements[0].box.hide();
//                                                   this.exportSVGElements[1].hide();
//                                                 },
//                                                 afterPrint: function () {
//                                                   this.exportSVGElements[0].box.show();
//                                                   this.exportSVGElements[1].show();
//                                                 },
//                                               },
//                                             },
//                                             events: {
//                                               beforePrint: function () {},
//                                               afterPrint: function () {},
//                                             },
//                                             title: {
//                                               text: t("percentage_schools_by_management"),
//                                             },
//                                             tooltip: {
//                                               valueSuffix: "%",
//                                               valueDecimals: 2,
//                                             },
//                                             credits: {
//                                               enabled: false,
//                                             },
//                                             plotOptions: {
//                                               pie: {
//                                                 size: "100%",
//                                                 dataLabels: {
//                                                   enabled: true,
//                                                   distance: -40,
//                                                   formatter: function () {
//                                                     return "<b>" + this.point.y + "%";
//                                                   },
//                                                   style: {
//                                                     fontSize: "16px",
//                                                     textOutline: "none",
//                                                     opacity: 0.7,
//                                                   },
//                                                 },
//                                                 center: ["50%", "50%"],
//                                                 showInLegend: true,
//                                               },
//                                               series: {
//                                                 allowPointSelect: true,
//                                                 cursor: "pointer",
//                                                 dataLabels: [
//                                                   {
//                                                     enabled: true,
//                                                     distance: 20,
//                                                   },
//                                                   {
//                                                     enabled: false,
//                                                     distance: -40,
//                                                     format: "{point.y:.2f}%",
//                                                     style: {
//                                                       fontSize: "0.6em",
//                                                       textOutline: "none",
//                                                       opacity: 0.7,
//                                                     },
          
//                                                     filter: {
//                                                       operator: ">",
//                                                       property: "percentage",
//                                                       value: 0,
//                                                     },
//                                                   },
//                                                 ],
//                                               },
//                                             },
//                                             legend: {
//                                               // title: {
//                                               //   text: "Key",
//                                               //   style: {
//                                               //     fontSize: "18px",
//                                               //   },
//                                               // },
//                                               layout: "horizontal",
//                                               align: "center",
//                                               verticalAlign: "bottom",
//                                               itemMarginTop: 10,
//                                               itemMarginBottom: 10,
//                                             },
//                                             series: [
//                                               {
//                                                 name: t("percentage"),
//                                                 colorByPoint: true,
//                                                 data: [
//                                                   {
//                                                     name: 'Foundational and Preparatory',
//                                                     y:  parseFloat(((map1[0] / total)*100).toFixed(2)),
//                                                     color: "#F5BF55",
//                                                   },
          
//                                                   {
//                                                     name: 'Middle',
//                                                     y:  parseFloat(((map1[1] / total)*100).toFixed(2)),
//                                                     color: "#E6694A",
//                                                   },
//                                                   {
//                                                     name: 'Secondary',
//                                                     y:   parseFloat(((map1[2] / total)*100).toFixed(2)),
//                                                     color: "#BCE263",
//                                                   }
//                                                 ],
//                                               },
//                                             ],
//                                             exporting: {
//                                               filename: t(
//                                                 "percentage_schools_by_management"
//                                               ),
//                                               csv: {
//                                                 columnHeaderFormatter: function (item) {
//                                                   if (
//                                                     !item ||
//                                                     item instanceof Highcharts.Axis
//                                                   ) {
//                                                     return t("category");
//                                                   }
//                                                   return item.name;
//                                                 },
//                                               },
//                                             },
//                                           }}
//                                           immutable={true}
//                                         />
//                                       </div>
//         );
// } 


export function SchoolGraph1013({ graphData,  groupKeys }) {
  const { t } = useTranslation();
console.log("graphData-----",graphData);
console.log("  groupKeys----",  groupKeys);
const map1={};
const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)': 14};


if(groupKeys.schManagementBroad){
  map1.categories=['State Govt.', 'Govt. Aided', 'Private Unaided', 'Central Govt.', 'Others'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'Headmaster', data: [null, null, null, null] },
      { name: 'Acting Head Teacher', data: [null, null, null, null] },
      { name: 'Principal', data: [null, null, null, null] },
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][0].data[index] = item['Headmaster'];
      map1['series'][1].data[index] = item['Acting Head Teacher'];
      map1['series'][2].data[index] = item['Principal'];
    }
  });
}else if(groupKeys.schManagementDesc){
  map1.categories=['Department of Education', 'Tribal Welfare Department', 'Local Body', 'Government Aided', 'Private Unaided (Recognized) ', 'Other State Govt. Managed ', 'Partially Govt. Aided', 'Unrecognized', 'Social Welfare Department', 'Ministry of Labour', 'Madrasa Private Unaided (Recognized) ', 'Madarsa Unrecognized', 'Madrasa Aided (Recognized)', 'Other Central Govt./PSU Schools','Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'Headmaster', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
      { name: 'Acting Head Teacher', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
      { name: 'Principal', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] }
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Detailed)'];
    if (managentDetailed[managementType] !== undefined) {
      const index = managentDetailed[managementType];
      map1['series'][0].data[index] = item['Headmaster'];
      map1['series'][1].data[index] = item['Acting Head Teacher'];
      map1['series'][2].data[index] = item['Principal'];
    }
  });
}
  return (
    <div className="impact-box-content-education">
  
      <div className="piechart-box mt-5 pb-5">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: "column",
              marginTop: 50,
              events: {
                beforePrint: function () {
                  this.exportSVGElements[0].box.hide();
                  this.exportSVGElements[1].hide();
                },
                afterPrint: function () {
                  this.exportSVGElements[0].box.show();
                  this.exportSVGElements[1].show();
                },
              },
            },
            xAxis: {
              categories: map1.categories,
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: "",
              },
            },
            title: {
              text: t("total_teachers_by_management_category"),
              style: {
                fontSize: '15px'  
              }
            },
            tooltip: {
              headerFormat: "<b>{point.x}</b><br/>",
              pointFormat: "{series.name}: {point.y}",
              pointFormatter: function () {
                return `<span style="color:${this.color}">\u25CF</span> ${
                  this.series.name
                }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
              },
            },
            plotOptions: {
              column: {
                stacking: "normal",
                dataLabels: {
                  enabled: true,
                  crop: false,
                  overflow: "none",
                  rotation: 0,
                  align: "center",
                  x: -2,
                  y: -5,
                  style: {
                    font: "13px Arial, sans-serif",
                    fontWeight: "600",
                    stroke: "transparent",
                    align: "center",
                  },
                  position: "top",
                  formatter: function () {
                    // return parseFloat(
                    //   this.y
                    // ).toFixed(0);
                    return this.y.toLocaleString("en-IN");
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemMarginTop: 10,
              itemMarginBottom: 10,
            },
            credits: {
              enabled: false,
            },
            series: map1.series,
            exporting: {
              filename: t("total_teacher_by_management_category"),
              csv: {
                columnHeaderFormatter: function (item) {
                  if (!item || item instanceof Highcharts.Axis) {
                    return t("category");
                  }
                  return item.name;
                },
              },
            },
          }}
          immutable={true}
        />
      </div>
    </div>
  );
}

export function SchoolGraph1014({ graphData,  groupKeys }) {
  const { t } = useTranslation();
console.log("graphData-----",graphData);
console.log("  groupKeys----",  groupKeys);
const map1={};
const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13,'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)': 14};


if(groupKeys.schManagementBroad){
  map1.categories=['State Govt.', 'Govt. Aided', 'Private Unaided', 'Central Govt.', 'Others'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'Secondary Schools', data: [null, null, null, null] },
      { name: 'Secondary Schools having Vocational course', data: [null, null, null, null] },
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Broad)'];
    if (managentBroad[managementType] !== undefined) {
      const index = managentBroad[managementType];
      map1['series'][0].data[index] = item['Number of Secondary Schools'];
      map1['series'][1].data[index] = item['Number of Secondary Schools having Vocational cource under NSQF at secondary level'];
    }
  });
}else if(groupKeys.schManagementDesc){
  map1.categories=['Department of Education', 'Tribal Welfare Department', 'Local Body', 'Government Aided', 'Private Unaided (Recognized) ', 'Other State Govt. Managed ', 'Partially Govt. Aided', 'Unrecognized', 'Social Welfare Department', 'Ministry of Labour', 'Madrasa Private Unaided (Recognized) ', 'Madarsa Unrecognized', 'Madrasa Aided (Recognized)', 'Other Central Govt./PSU Schools','Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)'];
  if (!map1['series']) {
    map1['series'] = [
      { name: 'Secondary Schools', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
      { name: 'Secondary Schools having Vocational course', data: [null, null, null, null,null, null, null, null,null, null, null, null, null, null] },
    ];
  }
  graphData.forEach((item) => {
    const managementType = item['School Management(Detailed)'];
    if (managentDetailed[managementType] !== undefined) {
      const index = managentDetailed[managementType];
      map1['series'][0].data[index] = item['Number of Secondary Schools'];
      map1['series'][1].data[index] = item['Number of Secondary Schools having Vocational cource under NSQF at secondary level'];
    }
  });
}
  return (
    <div className="impact-box-content-education">
  
      <div className="piechart-box mt-5 pb-5">
        <HighchartsReact
          highcharts={Highcharts}
          options={{
            chart: {
              type: "column",
              marginTop: 50,
              events: {
                beforePrint: function () {
                  this.exportSVGElements[0].box.hide();
                  this.exportSVGElements[1].hide();
                },
                afterPrint: function () {
                  this.exportSVGElements[0].box.show();
                  this.exportSVGElements[1].show();
                },
              },
            },
            xAxis: {
              categories: map1.categories,
            },
            yAxis: {
              allowDecimals: false,
              min: 0,
              title: {
                text: "",
              },
            },
            title: {
              text: t("total_teachers_by_management_category"),
              style: {
                fontSize: '15px'  
              }
            },
            tooltip: {
              headerFormat: "<b>{point.x}</b><br/>",
              pointFormat: "{series.name}: {point.y}",
              pointFormatter: function () {
                return `<span style="color:${this.color}">\u25CF</span> ${
                  this.series.name
                }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
              },
            },
            plotOptions: {
              column: {
                stacking: "normal",
                dataLabels: {
                  enabled: true,
                  crop: false,
                  overflow: "none",
                  rotation: 0,
                  align: "center",
                  x: -2,
                  y: -5,
                  style: {
                    font: "13px Arial, sans-serif",
                    fontWeight: "600",
                    stroke: "transparent",
                    align: "center",
                  },
                  position: "top",
                  formatter: function () {
                    // return parseFloat(
                    //   this.y
                    // ).toFixed(0);
                    return this.y.toLocaleString("en-IN");
                  },
                },
              },
            },
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
              itemMarginTop: 10,
              itemMarginBottom: 10,
            },
            credits: {
              enabled: false,
            },
            series: map1.series,
            exporting: {
              filename: t("total_teacher_by_management_category"),
              csv: {
                columnHeaderFormatter: function (item) {
                  if (!item || item instanceof Highcharts.Axis) {
                    return t("category");
                  }
                  return item.name;
                },
              },
            },
          }}
          immutable={true}
        />
      </div>
    </div>
  );
}


export function SchoolGraph2Manage1014({ graphData,  groupKeys }) {
  const { t } = useTranslation();
  const map1=[0,0,0,0,0];
  const managentBroad= {'State Govt.':0, 'Govt. Aided':1, 'Private Unaided':2, 'Central Govt.':3, 'Others':4};
  const managentDetailed = {'Department of Education':0, 'Tribal Welfare Department':1, 'Local Body':2, 'Government Aided':3, 'Private Unaided (Recognized) ':4, 'Other State Govt. Managed ':5, 'Partially Govt. Aided':6, 'Unrecognized':7, 'Social Welfare Department':8, 'Ministry of Labour':9, 'Madrasa Private Unaided (Recognized) ':10, 'Madarsa Unrecognized':11, 'Madrasa Aided (Recognized)':12, 'Other Central Govt./PSU Schools':13, 'Veda Schools/Gurukuls/Pathashalas(Aided/Unaided)': 14};
  
  
  // if(groupKeys.schCategoryBroad){
  
console.log("graphData-----",graphData)

    graphData.forEach((item) => {
      const managementType = item['School Management(Broad)'];
      if (managentBroad[managementType] !== undefined) {
        const index = managentBroad[managementType];
        map1[index]= map1[index] + item['Number of Secondary Schools'] + item['Number of Secondary Schools having Vocational cource under NSQF at secondary level'];
      }
    });
  
    console.log("map1----------------",map1)
  
  // }
  // else if(groupKeys.schCategoryDesc){
  //   map1.categories=['Foundational and Preparatory','Middle (1-8)','Middle (6-8)','Secondary (1-10)','Secondary (1-12)','Secondary (6-10)','Secondary (6-12)','Secondary (9-10)','Secondary (9-12)','Secondary (11-12)'];
  //   if (!map1['series']) {
  //     map1['series'] = [
  //       { name: 'State Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
  //       { name: 'Govt. Aided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
  //       { name: 'Private Unaided', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
  //       { name: 'Central Govt.', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] },
  //       { name: 'Others', data: [0, 0, 0,0, 0, 0,0, 0, 0,0] }
  //     ];
  //   }
  //   graphData.forEach((item) => {
  //     const managementType = item['School Management(Broad)'];
  //     if (managentBroad[managementType] !== undefined) {
  //       const index = managentBroad[managementType];
  //       map1['series'][index].data = [map1['series'][index].data[0]+item['Foundational and Preparatory'],map1['series'][index].data[1]+item['Middle (1-8)'], map1['series'][index].data[2]+item['Middle (6-8)'], map1['series'][index].data[3]+item['Secondary (1-10)'], map1['series'][index].data[4]+item['Secondary (1-12)'] , map1['series'][index].data[5]+item['Secondary (6-10)'] , map1['series'][index].data[6]+item['Secondary (6-12)'], map1['series'][index].data[7]+item['Secondary (9-10)'], map1['series'][index].data[8]+item['Secondary (9-12)'], map1['series'][index].data[9]+item['Secondary (11-12)']] ;
  //     }
  //   });
  // }
  console.log("map1----",map1);
  const total = map1.reduce((sum, value) => sum + value, 0);
  console.log("Others---",((map1[4] / total)*100).toFixed(2))
    return (
       <div className="piechart-box mt-4">
                                    <HighchartsReact
                                      highcharts={Highcharts}
                                      options={{
                                        chart: {
                                          type: "pie",
                                          marginTop: 50,
                                          events: {
                                            beforePrint: function () {
                                              this.exportSVGElements[0].box.hide();
                                              this.exportSVGElements[1].hide();
                                            },
                                            afterPrint: function () {
                                              this.exportSVGElements[0].box.show();
                                              this.exportSVGElements[1].show();
                                            },
                                          },
                                        },
                                        events: {
                                          beforePrint: function () {},
                                          afterPrint: function () {},
                                        },
                                        title: {
                                          text: t("percentage_schools_by_management"),
                                        },
                                        tooltip: {
                                          valueSuffix: "%",
                                          valueDecimals: 2,
                                        },
                                        credits: {
                                          enabled: false,
                                        },
                                        plotOptions: {
                                          pie: {
                                            size: "100%",
                                            dataLabels: {
                                              enabled: true,
                                              distance: -40,
                                              formatter: function () {
                                                return "<b>" + this.point.y + "%";
                                              },
                                              style: {
                                                fontSize: "16px",
                                                textOutline: "none",
                                                opacity: 0.7,
                                              },
                                            },
                                            center: ["50%", "50%"],
                                            showInLegend: true,
                                          },
                                          series: {
                                            allowPointSelect: true,
                                            cursor: "pointer",
                                            dataLabels: [
                                              {
                                                enabled: true,
                                                distance: 20,
                                              },
                                              {
                                                enabled: false,
                                                distance: -40,
                                                format: "{point.y:.2f}%",
                                                style: {
                                                  fontSize: "0.6em",
                                                  textOutline: "none",
                                                  opacity: 0.7,
                                                },
      
                                                filter: {
                                                  operator: ">",
                                                  property: "percentage",
                                                  value: 0,
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        legend: {
                                          // title: {
                                          //   text: "Key",
                                          //   style: {
                                          //     fontSize: "18px",
                                          //   },
                                          // },
                                          layout: "horizontal",
                                          align: "center",
                                          verticalAlign: "bottom",
                                          itemMarginTop: 10,
                                          itemMarginBottom: 10,
                                        },
                                        series: [
                                          {
                                            name: t("percentage"),
                                            colorByPoint: true,
                                            data: [
                                              {
                                                name: 'State Govt.',
                                                y: parseFloat((map1[0] / total).toFixed(4) * 100),
                                                color: "#F5BF55",
                                              },
      
                                              {
                                                name: 'Govt. Aided',
                                                y: parseFloat(((map1[1] / total)*100).toFixed(2)),
                                                color: "#E6694A",
                                              },
                                              {
                                                name: 'Private Unaided',
                                                y:parseFloat(((map1[2] / total)*100).toFixed(2)),
                                                color: "#BCE263",
                                              },
      
                                              {
                                                name: 'Central Govt.',
                                                y: parseFloat(((map1[3] / total)*100).toFixed(2)),
                                                color: "#1d1575",
                                              },
                                              {
                                                name: 'Others',
                                                y: parseFloat(((map1[4] / total)*100).toFixed(2)),
                                                color: "#751539",
                                              }
                                              // {
                                              //   name: 'Others',
                                              //   y: parseFloat((map1[4] / total).toFixed(4) * 100),
                                              //   color: "#751539",
                                              // }
                                            ],
                                          },
                                        ],
                                        exporting: {
                                          filename: t(
                                            "percentage_schools_by_management"
                                          ),
                                          csv: {
                                            columnHeaderFormatter: function (item) {
                                              if (
                                                !item ||
                                                item instanceof Highcharts.Axis
                                              ) {
                                                return t("category");
                                              }
                                              return item.name;
                                            },
                                          },
                                        },
                                      }}
                                      immutable={true}
                                    />
                                  </div>
    );
}



export function Graph4011({ graphData }) {
  console.log('graphData', graphData)
  const { t } = useTranslation();
  const map1={};  
  
    map1.categories=['Foundational', 'Preparatory', 'Middle', 'Secondary'];

    if (!map1['series']) {
      map1['series'] = [
        { name: 'Boys', data: [0, 0, 0, 0] },
        { name: 'Girls', data: [0, 0, 0, 0] },
        { name: 'Overall', data: [0, 0, 0, 0] },
      ];
    }

    graphData.forEach((item) => {
        map1['series'][0].data = [parseFloat(item['priB']), parseFloat(item['upriB']), parseFloat(item['secB']),parseFloat(item['hsecB'])];
        map1['series'][1].data = [parseFloat(item['priG']), parseFloat(item['upriG']),parseFloat(item['secG']), parseFloat(item['hsecG'])];
        map1['series'][2].data = [parseFloat(item['priT']) ,parseFloat(item['upriT']), parseFloat(item['secT']), parseFloat(item['hsecT'])];
    });
  
    console.log("map1-----",map1)
  
    return (
      <div className="impact-box-content-education">
    
        <div className="piechart-box mt-5 pb-5">
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: {
                type: "column",
                marginTop: 50,
                events: {
                  beforePrint: function () {
                    this.exportSVGElements[0].box.hide();
                    this.exportSVGElements[1].hide();
                  },
                  afterPrint: function () {
                    this.exportSVGElements[0].box.show();
                    this.exportSVGElements[1].show();
                  },
                },
              },
              xAxis: {
                categories: map1.categories,
              },
              yAxis: {
                allowDecimals: false,
                min: 0,
                title: {
                  text: "",
                },
              },
              title: {
                text: "Net Enrolment Rate by Gender and Level of School Education",
                style: {
                  fontSize: '15px'  
                }
              },
              tooltip: {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat: "{series.name}: {point.y}",
                pointFormatter: function () {
                  return `<span style="color:${this.color}">\u25CF</span> ${
                    this.series.name
                  }: <b>${this.y.toLocaleString("en-IN")}</b><br/>`;
                },
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  dataLabels: {
                    enabled: true,
                    crop: false,
                    overflow: "none",
                    rotation: 0,
                    align: "center",
                    x: -2,
                    y: -5,
                    style: {
                      font: "13px Arial, sans-serif",
                      fontWeight: "600",
                      stroke: "transparent",
                      align: "center",
                    },
                    position: "top",
                    formatter: function () {
                      
                      // return parseFloat(
                      //   this.y
                      // ).toFixed(0);
                      return this.y.toLocaleString("en-IN");
                    },
                  },
                },
              },
              legend: {
                layout: "horizontal",
                align: "center",
                verticalAlign: "bottom",
                itemMarginTop: 10,
                itemMarginBottom: 10,
              },
              credits: {
                enabled: false,
              },
              series: map1.series,
              exporting: {
                filename: t("total_teacher_by_management_category"),
                csv: {
                  
                  columnHeaderFormatter: function (item) {
                    if (!item || item instanceof Highcharts.Axis) {
                      return t("category");
                    }
                    return item.name;
                  },
                },
              },
            }}
            immutable={true}
          />
        </div>
      </div>
    );
  }



